<template>
  <SettlementDeliveryCard
    status=""
    status-color="warning"
    :order-id="settlement.orderId"
    :is-mobile="$q.screen.xs"
    v-bind="$attrs"
  />
</template>

<script>
import sendSettlementEvent from '../../utils/send-settlement-event';
import { mapState } from 'vuex';

export default {
  name: 'SettlementDeliveryStep',
  computed: {
    ...mapState({
      settlement: (state) => state.settlement.settlement
    })
  },
  mounted() {
    sendSettlementEvent({
      label: 'car-delivery'
    });
  },
  components: {
    SettlementDeliveryCard: () =>
      import('../../components/molecule/settlement-delivery-card')
  }
};
</script>
